<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Zgnlkc/tc-custom/9781940669311.jpg?1708776416438" alt="This image is the cover for the book Washingtons. Volume 6, Part 1, The Washingtons: A Family History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Washingtons. Volume 6, Part 1, The Washingtons: A Family History
      </h1>
      <p class="bookDescription body article font2">
        <b>Part of a series filled with “gratifying detail” about the ancestry of the first US President, this volume contains the tenth-generation descendants. (Robert K. Krick, author of <i>The Smoothbore Volley that Doomed the Confederacy, Stonewall Jackson at Cedar Mountain,</i> and <i>Lee’s Colonels</i>)</b><br/><br/>This is the sixth volume of Dr. Justin Glenn’s comprehensive history that traces the “Presidential line” of the Washingtons, the vast family originated by the immigrant John Washington, who settled in Westmoreland Co., Va., in 1657, married Anne Pope, and became the great-grandfather of President George Washington. This volume contains the late nineteenth and twentieth century born descendants of John Washington’s daughter, Anne (Washington) Wright and as such transports the reader through many of the major historical events of those eras by providing the stories of the family members who lived through them. <br/><br/>Although structured in a genealogical format for the sake of clarity, this is no bare bones genealogy but a true family history with over 1,200 detailed biographical narratives. These in turn strive to convey the greatness of the family that produced not only The Father of His Country but many others, great and humble, who struggled to build that country.<br/><br/>“It is surprising that no comprehensive family history has been published. Justin M. Glenn’s <i>The Washingtons: A Family History</i> finally fills this void for the branch to which General and President George Washington belonged, identifying some 63,000 descendants.” —John Frederick Dorman, editor of <i>The Virginia Genealogist</i> (1957–2006) and author of <i>Adventurers of Purse and Person</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Justin Glenn
      </h2>
      
      <p class="authorDescription body article">Justin Matthews Glenn was born in Little Rock, Arkansas, and raised in Glendale and Phoenix, Arizona. He graduated from Stanford University [B.A., Classics, 1967; magna cum laude, Phi Beta Kappa] and was a Woodrow Wilson Fellow at Princeton University [M.A., Classics, 1969; Ph.D., Classics, 1970]. His career as a professor of Classics at the University of Georgia and Florida State University spanned thirty-five years, and he has published over seventy articles, notes, and reviews in his field. A distant cousin of George Washington, he has served as Registrar General of the National Society of the Washington Family Descendants since 2002.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c3d3b28